/**
 * @module geo
 */
import {GeoBusFactory} from './bus';
import {BusService} from './bus/bus.service';

/**
 * handle current Ifranme container of app
 * Object is created by application and should be not modified
 */
export class IframeContainer {
  /**
   * Url of the iframe
   */
  public url: string;
  /**
   * Id in the dom of the iframe
   */
  public idElement: string;

  /**
   * @private
   */
  public element?: HTMLElement;
  /**
   * @private
   */
  public iframe?: HTMLIFrameElement;
  /**
   * Bus service communicating with app
   */
  public bus: GeoBusFactory;

  /**
   * Unique identifier for the iframe
   */
  public uidApp: string;

  constructor(
      public idElementArg: string, url: string, bus: GeoBusFactory,
      uidApp: string) {
    this.idElement = idElementArg;
    this.url = url;
    this.bus = bus;
    this.uidApp = uidApp;
  }

  /**
   * Construct the Iframe and render the GEO App
   */
  public render(): HTMLIFrameElement {
    const myElement: HTMLElement|null =
        document.getElementById(this.idElement as string);
    if (myElement == null) {
      throw new TypeError('Invalid Html id');
    } else {
      this.element = myElement;
    }
    const iframe = window.document.createElement('IFRAME') as HTMLIFrameElement;
    iframe.id = 'geoappiframe_' + this.uidApp;
    iframe.src = (this.url.indexOf('?') !== -1) ?
        this.url + '&uid=' + this.uidApp :
        this.url + '?uid=' + this.uidApp;
    iframe.frameBorder = '0';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    this.iframe = iframe;
    this.element.innerHTML = '';
    this.element.appendChild(iframe);
    this.bus.setClientReceiver(this.iframe, this.uidApp);
    return iframe;
  }
}
